import { updateReplenishableByProduct } from "../../slices/productsSlice";
import { LoaderSpinner } from "../LoaderSpinner";
import { useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

export const IsReplanishable = ({
    product,
    access,
    disabled,
    isLoading,
    withoutLoader = false,
    groupUpdate,
    updateCallback,
    containerClassname
}) => {
    const dispatch = useDispatch();

    const handleIsReplenishableChange = async (productId, replenishableValue) => {
        if (disabled) return;
        if (access === "edit") {
            await dispatch(updateReplenishableByProduct({
                productId,
                isReplenishable: replenishableValue || false,
                requestToUpdate: groupUpdate,
            }));
            await updateCallback?.();
        }
    };

    return (
        <div className="flex items-center gap-2 flex-row">
            <div className="relative">
                <div className={`flex items-center gap-2 ${containerClassname || ""}`}>
                    {(isLoading && !withoutLoader) && (<LoaderSpinner height='20' width='20' colorSpinner='black' border='3' />)}
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            key={`${product?.isReplenishable}`}
                            type="checkbox"
                            checked={product?.isReplenishable}
                            onChange={(e) => {
                                handleIsReplenishableChange(product?.id, e.target.checked);
                            }}
                            disabled={isLoading || access !== "edit" || disabled}
                            className="sr-only peer"
                        />
                        <div className={`w-11 h-6 bg-gray-200 ${disabled ? "bg-gray-400 cursor-not-allowed" : ""} peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600`}></div>
                    </label>
                </div>
            </div>
            {disabled && (
                <div className="flex items-center">
                    <InformationCircleIcon
                        className="h-5 w-5 text-blue-500"
                        data-tip
                        data-for={`repl-disabled-${product?.id || 'item'}`}
                    />
                    <ReactTooltip
                        id={`repl-disabled-${product?.id || 'item'}`}
                        effect="solid"
                        place="top"
                    >
                        <span>This feature is only available when the product status is ACTIVE</span>
                    </ReactTooltip>
                </div>
            )}
        </div>
    )
}